// extracted by mini-css-extract-plugin
export default {"footer":"Main_footer__Qlnff","copy_right":"Main_copy_right__y6x4-","copy_right_highlight":"Main_copy_right_highlight__kEmgo","link":"Main_link__1e5C1"};